import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ConfirmationModal } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useOverlayContext } from '~/contexts';
import { RichTextViewerWithFetch } from './RichTextViewerWithFetch/RichTextViewerWithFetch';
export const { RichTextViewerModalTID } = getTestIds();
export function useShowRichTextViewerModal() {
    const { showModal } = useOverlayContext();
    return useCallback((_0)=>{
        let { biName = 'rich_text_viewer_modal', closeOnEscapeKey, closeOnClickOutside } = _0, props = _object_without_properties(_0, [
            "biName",
            "closeOnEscapeKey",
            "closeOnClickOutside"
        ]);
        return showModal({
            biName,
            openBottomSheetOnMobile: true,
            closeOnEscapeKey,
            closeOnClickOutside,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(RichTextViewerModal, _object_spread_props(_object_spread({}, props), {
                    show: true,
                    onClose: dismissModal
                }));
            }
        });
    }, [
        showModal
    ]);
}
export default function RichTextViewerModal(param) {
    let { title, text, fetchText, onClose, queryKey } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'rich_text_viewer_confirm'
            },
            secondaryButton: {
                name: 'rich_text_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: RichTextViewerModalTID.Root(),
        content: /*#__PURE__*/ _jsx("div", {
            "data-testid": RichTextViewerModalTID.Content(),
            style: {
                width: '100%',
                textAlign: 'left'
            },
            children: /*#__PURE__*/ _jsx(RichTextViewerWithFetch, {
                queryKey: queryKey,
                text: text,
                fetchText: fetchText
            })
        })
    });
}
